import clsx from 'clsx';
import {Dispatch, SetStateAction, SVGProps} from 'react';
import CustomLink from '../customLink/customLink';
import * as styles from './tabs.module.css';

export interface ITabsData {
    title: string,
    id: string,
    to: string,
    icon?: React.JSXElementConstructor<SVGProps<SVGSVGElement>>,
    badge?: number,
    state?: string,
    setState?: Dispatch<SetStateAction<string>>,
}

interface ITabsProps {
    data: Array<ITabsData>,
    interceptLinks?: {
        status: boolean,
        action: () => void,
        setOnConfirm: (confirm: () => () => void) => void,
    },
    noLinks?: boolean,
}

const Tabs = ({
    data,
    interceptLinks,
    noLinks,
}: ITabsProps) => (
    <div className={styles.root}>
        {!noLinks && data && Array.isArray(data) && data.map(({
            title,
            icon: Icon,
            to,
            badge,
        }, index) => (
            <CustomLink
                key={`tab-${index}`}
                to={to}
                intercept={interceptLinks}
                className={styles.tab}
                isTab={true}
            >
                {Icon && (
                    <span className={styles.tabIcon}>
                        <Icon/>
                    </span>
                )}
                {title}
                {badge && (
                    <span
                        className={clsx(
                            styles.badge,
                            badge > 99 && styles.plus,
                        )}
                    >
                        {badge < 99 ? badge : '99'}
                    </span>
                )}
            </CustomLink>
        ))}
        {noLinks && data.map(({
            id,
            title,
            icon: Icon,
            state,
            setState,
        }, index) => (
            <span
                key={`tab-${index}`}
                style={{cursor: 'pointer'}}
                className={clsx(
                    styles.tab,
                    id === state && styles.tabActive,
                )}
                onClick={setState ? () => {setState(id);} : () => {}}
            >
                {Icon && (
                    <span className={styles.tabIcon}>
                        <Icon/>
                    </span>
                )}
                {title}
            </span>
        ))}
    </div>
);

export default Tabs;
